<div class="">
    <!-- <form [formGroup]="coForm">
        <div class="row">
            <div class="col-md-2">
                <h4>{{ 'ADDITIONAL_INFO' | translate }}</h4>
            </div>
            <div class="col-md-10">
                <textarea rows="3" class="form-control" formControlName="bdNotes"
                    [ngClass]="{ 'is-invalid': coSubmitted && fp.bdNotes.errors }"
                    placeholder="Addtional info"></textarea>
                <div *ngIf="coSubmitted && fp.bdNotes.errors" class="invalid-feedback">
                    <div *ngIf="fp.bdNotes.errors.required">{{ 'ADDITIONAL_INFO_IS_REQUIRED' | translate }}</div>
                </div>
            </div>
        </div>
    </form> -->

    <form class="card-block" [formGroup]="paymentForm">
        <div class="row">
            <div class="col-md-12">
                <div class="row mb-10">
                        <label class="col-md-1">{{ 'CLIENT' | translate }}</label>
                    <div class="col-md-4">
                        <ng-select [clearable]="false"
                            [ngClass]="{'is-invalid': paymentSubmitted && fp.clientId.errors, 'disabled-dropdown': allMyClients.length ===1 }"
                            bindLabel="fullName" bindValue="id" (change)="onPaymentClientChange($event)" [items]="allMyClients" formControlName="clientId">
                        </ng-select>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <label *ngIf="!isNewPaymentMethod" class="col-md-4">{{ 'SELECT_FROM_YOUR_SAVED_PAYMENT_METHODS' | translate }}</label>
                            <div *ngIf="!isNewPaymentMethod" class="col-md-6">
                                <ng-select [ngClass]="{'is-invalid': paymentSubmitted && fp.methodId.errors?.required}"
                                    bindLabel="nickname" (change)="onPaymentMethodChange($event)" bindValue="id"
                                    [items]="myPaymentMethods" formControlName="methodId">
                                </ng-select>
                                <div *ngIf="paymentSubmitted && fp.methodId.errors" class="invalid-feedback">
                                    <div *ngIf="fp.methodId.errors?.required">{{ 'PLEASE_SELECT_A_PAYMENT_METHOD' | translate }}
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!isNewPaymentMethod" class="col-md-2">
                                <button (click)="onChangePaymentMethodSelectionMode(true)" class="btn">{{ 'ADD_NEW' | translate }}</button>
                            </div>
                            <div *ngIf="isNewPaymentMethod" class="col-md-12 product-checkout-actions">
                                <button (click)="onChangePaymentMethodSelectionMode(false)" class="btn">{{ 'SHOW_SAVED_PAYMENT_METHODS' | translate }}</button>
                            </div>

                        </div>
                        <div *ngIf="isNewPaymentMethod" class="row">
                            <div class="col-md-8">
                                <div class="row mb-10">
                                    <div class="col-md-12">
                                        <div fxLayout="column">
                                            <h2>{{ 'CREDIT_CARD' | translate }}</h2>
                                            <p>{{ 'PAY_SECURELY_USING_YOUR_CREDIT_CARD' | translate }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-10">
                                    <div class="col-md-6">
                                        <input type="text" class="form-control" formControlName="firstName"
                                            [ngClass]="{ 'is-invalid': paymentSubmitted && fp.firstName.errors }"
                                            [placeholder]="'FIRST_NAME_ON_CARD' | translate">
                                        <div *ngIf="paymentSubmitted && fp.firstName.errors" class="invalid-feedback">
                                            <div *ngIf="fp.firstName.errors.required">{{ 'FIRST_NAME_IS_REQUIRED' | translate }}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <input type="text" class="form-control" formControlName="lastName"
                                            [ngClass]="{ 'is-invalid': paymentSubmitted && fp.lastName.errors }"
                                            [placeholder]="'LAST_NAME_ON_CARD' | translate">
                                        <div *ngIf="paymentSubmitted && fp.lastName.errors" class="invalid-feedback">
                                            <div *ngIf="fp.lastName.errors.required">{{ 'LAST_NAME_IS_REQUIRED' | translate }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-10">
                                    <div class="col-md-12">
                                        <input type="text" class="form-control" formControlName="cardNumber"
                                            mask="0000-0000-0000-0000"
                                            [ngClass]="{ 'is-invalid': paymentSubmitted && fp.cardNumber.errors }"
                                            [placeholder]="'CARD_NUMBER' | translate">
                                        <div *ngIf="paymentSubmitted && fp.cardNumber.errors" class="invalid-feedback">
                                            <div *ngIf="fp.cardNumber.errors.required">{{ 'CARD_NUMBER_IS_REQUIRED' | translate }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-10">
                                    <div class="col-md-6">
                                        <input type="text" class="form-control" mask="00/00"
                                            formControlName="cardExpiryDate"
                                            [ngClass]="{ 'is-invalid': paymentSubmitted && fp.cardExpiryDate.errors }"
                                            [placeholder]="'EXPIRY_DATE' | translate">
                                        <div *ngIf="paymentSubmitted && fp.cardExpiryDate.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="fp.cardExpiryDate.errors.required">{{ 'EXPIRY_DATE_IS_REQUIRED' | translate }}</div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <input type="text" mask="0000" class="form-control" formControlName="cardCVV"
                                            [ngClass]="{ 'is-invalid': paymentSubmitted && fp.cardCVV.errors }"
                                            [placeholder]="'CVV' | translate">
                                        <div *ngIf="paymentSubmitted && fp.cardCVV.errors" class="invalid-feedback">
                                            <div *ngIf="fp.cardCVV.errors.required">{{ 'CVV_IS_REQUIRED' | translate }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-10">
                                    <div class="col-md-12">
                                        <input type="text" class="form-control" formControlName="nickname"
                                        [ngClass]="{ 'is-invalid': paymentSubmitted && fp.nickname.errors }"
                                        [placeholder]="'CARD_NICKNAME' | translate">
                                    <div *ngIf="paymentSubmitted && fp.nickname.errors" class="invalid-feedback">
                                        <div *ngIf="fp.nickname.errors.required">{{ 'CARD_NICKNAME_IS_REQUIRED' | translate }}</div>
                                    </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-2">
                <h4>{{ 'BILLING_DETAILS' | translate }}</h4>
            </div>
            <div class="col-md-10">
                <div class="row mb-10">
                    <div class="col-md-12">
                        <input type="text" class="form-control" formControlName="address"
                            [ngClass]="{ 'is-invalid': coSubmitted && fp.adAddress.errors }" [placeholder]="'STREET_INFO' | translate">
                        <div *ngIf="coSubmitted && fp.adAddress.errors" class="invalid-feedback">
                            <div *ngIf="fp.adAddress.errors.required">{{ 'ADDRESS_IS_REQUIRED' | translate }}</div>
                        </div>
                    </div>
                </div>
                <div class="row mb-10">
                    <div class="col-md-4">
                        <input type="text" class="form-control" formControlName="city"
                            [ngClass]="{ 'is-invalid': coSubmitted && fp.city.errors }" [placeholder]="'CITY' | translate">
                        <div *ngIf="coSubmitted && fp.city.errors" class="invalid-feedback">
                            <div *ngIf="fp.city.errors.required">{{ 'CITY_IS_REQUIRED' | translate }}</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <input type="text" class="form-control" formControlName="state"
                            [ngClass]="{ 'is-invalid': coSubmitted && fp.state.errors }" [placeholder]="'STATE' | translate">
                        <div *ngIf="coSubmitted && fp.state.errors" class="invalid-feedback">
                            <div *ngIf="fp.state.errors.required">{{ 'STATE_IS_REQUIRED' | translate }}</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <input type="text" class="form-control" formControlName="zip"
                            [ngClass]="{ 'is-invalid': coSubmitted && fp.zip.errors }" [placeholder]="'ZIP' | translate">
                        <div *ngIf="coSubmitted && fp.zip.errors" class="invalid-feedback">
                            <div *ngIf="fp.zip.errors.required">{{ 'ZIP_IS_REQUIRED' | translate }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="height: 5px">
            <hr>
        </div>
        <div class="product-checkout-terms">
            <div class="row">
                    <div class="col-md-9">
                        <input type="checkbox" id="agreeTerms" formControlName="agreeTerms"
                            class="form-check-input" />
                    </div>
                    <label class="col-md-3" for="agreeTerms">{{ 'I_HAVE_READ_AND_AGREED_THE_WEBSITE' | translate }}
                        <a href="https://shop.franchisefocusedmarketing.com/terms-of-service/" target="_blank">{{ 'TERMS_AND_CONDITIONS' | translate }}</a></label>
                    <label *ngIf="paymentSubmitted && fp.agreeTerms.errors?.required"
                        class="col-sm-11 product-checkout-terms-error">{{ 'PLEASE_ACCEPT_THE_AGREEMENT' | translate }}</label>
            </div>
        </div>
    </form>
</div>
